import React from 'react';
import PropTypes from 'prop-types';
import { useBottomScrollListener } from 'react-bottom-scroll-listener';

import Spinner from '../Spinner';
import useFileReactionPicker from './useFileReactionPicker';

const propTypes = {
  photoId: PropTypes.string,
  videoId: PropTypes.string,
  onReactionSelected: PropTypes.func,
};

const FileReactionPicker = ({ photoId, videoId, onReactionSelected }) => {
  const {
    systemStickers,
    loading,
    loadMore,
    onReactionCreate,
    onReactionDelete,
    accountFileReaction,
  } = useFileReactionPicker({
    photoId,
    videoId,
  });

  const scrollRef = useBottomScrollListener(() => {
    if (systemStickers?.total > systemStickers?.records?.length) {
      loadMore();
    }
  }, 200);

  if (loading) {
    return (
      <div className="file-reaction-picker-wrapper">
        <div className="d-flex justify-content-center align-items-center">
          <Spinner className="m-auto" />
        </div>
      </div>
    );
  }

  return (
    <div className="file-reaction-picker-wrapper">
      <div className="file-reaction-picker-list" ref={scrollRef}>
        {systemStickers &&
          systemStickers.records.map(systemSticker => {
            return (
              <button
                key={systemSticker.id}
                className="btn-sticker-select"
                onClick={() => {
                  if (
                    accountFileReaction?.system_sticker?.id === systemSticker.id
                  ) {
                    onReactionDelete(systemSticker.id);
                  } else {
                    onReactionCreate(systemSticker);
                  }
                  onReactionSelected?.();
                }}
              >
                <img src={systemSticker.asset_image.url} alt="" />
              </button>
            );
          })}
      </div>
    </div>
  );
};

FileReactionPicker.propTypes = propTypes;

export default FileReactionPicker;
